
// Configure FontAwesome
import { config, library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

// Light
import {
  faAnalytics as falAnalytics,
  faArrowAltUp as falArrowAltUp,
  faArrowAltToRight as falArrowAltToRight,
  faArrowDown as falArrowDown,
  faArrowLeft as falArrowLeft,
  faArrowRight as falArrowRight,
  faArrowUp as falArrowUp,
  faArrows as falArrows,
  faBalanceScale as falBalanceScale,
  faBell as falBell,
  faBoxes as falBoxes,
  faBinoculars as falBinoculars,
  faBriefcase as falBriefcase,
  faBug as falBug,
  faCalendarAlt as falCalendarAlt,
  faChartArea as falChartArea,
  faChartBar as falChartBar,
  faCheck as falCheck,
  faChevronDoubleLeft as falChevronDoubleLeft,
  faChevronDoubleRight as falChevronDoubleRight,
  faChevronDown as falChevronDown,
  faChevronLeft as falChevronLeft,
  faChevronRight as falChevronRight,
  faChevronUp as falChevronUp,
  faCommentAltDots as falCommentAltDots,
  faCommentPlus as falCommentPlus,
  faCodeBranch as falCodeBranch,
  faCog as falCog,
  faCogs as falCogs,
  faCopy as falCopy,
  faClock as falClock,
  faDownload as falDownload,
  faEdit as falEdit,
  faExchange as falExchange,
  faExclamationTriangle as falExclamationTriangle,
  faExternalLinkSquare as falExternalLinkSquare,
  faEye as falEye,
  faEyeSlash as falEyeSlash,
  faFile as falFile,
  faFileExport as falFileExport,
  faFilter as falFilter,
  faGlobe as falGlobe,
  faHandshake as falHandshake,
  faInfoCircle as falInfoCircle,
  faImage as falImage,
  faKeyboard as falKeyboard,
  faLink as falLink,
  faLongArrowDown as falLongArrowDown,
  faMoneyCheckAlt as falMoneyCheckAlt,
  faMoneyCheckEditAlt as falMoneyCheckEditAlt,
  faPaperclip as falPaperclip,
  faPaperPlane as falPaperPlane,
  faPlay as falPlay,
  faPlayCircle as falPlayCircle,
  faPlus as falPlus,
  faQuestionCircle as falQuestionCircle,
  faReceipt as falReceipt,
  faSave as falSave,
  faSearch as falSearch,
  faSpinner as falSpinner,
  faSquareFull as falSquareFull,
  faStar as falStar,
  faTachometerAltFast as falTachometerAltFast,
  faTasks as falTasks,
  faTerminal as falTerminal,
  faTimes as falTimes,
  faTrashAlt as falTrashAlt,
  faUserCircle as falUserCircle,
  faUserFriends as falUserFriends
} from '@fortawesome/pro-light-svg-icons'

// Regular
import {
  faCheck as farCheck,
  faTimes as farTimes,
  faSortAmountUp as farSortAmountUp,
  faSortAmountDown as farSortAmountDown
} from '@fortawesome/pro-regular-svg-icons'

// Solid
import {
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faArrowAltUp as fasArrowAltUp,
  faBell as fasBell,
  faBold as fasBold,
  faCheck as fasCheck,
  faCircle as fasCircle,
  faImage as fasImage,
  faInfoCircle as fasInfoCircle,
  faItalic as fasItalic,
  faExclamationTriangle as fasExclamationTriangle,
  faFileCsv as fasFileCsv,
  faFilePdf as fasFilePdf,
  faFileExcel as fasFileExcel,
  faH1 as fasH1,
  faH2 as fasH2,
  faH3 as fasH3,
  faHorizontalRule as fasHorizontalRule,
  faLink as fasLink,
  faListOl as fasListOl,
  faListUl as fasListUl,
  faLongArrowUp as fasLongArrowUp,
  faLongArrowDown as fasLongArrowDown,
  faMinus as fasMinus,
  faRedo as fasRedo,
  faStar as fasStar,
  faUnderline as fasUnderline,
  faUndo as fasUndo
} from '@fortawesome/pro-solid-svg-icons'

// Brands
import {
  faCcAmex as fabCcAmex,
  faCcMastercard as fabCcMastercard,
  faCcVisa as fabCcVisa,
  faFacebook as fabFacebook,
  faFacebookSquare as fabFacebookSquare,
  faPaypal as fabPaypal,
  faYoutube as fabYoutube
} from '@fortawesome/free-brands-svg-icons'

// Duotone
import {
  faLineColumns as fadLineColumns,
  faGripHorizontal as fadGripHorizontal
} from '@fortawesome/pro-duotone-svg-icons'

// Disable CSS injection from FA core, helps for CSP
config.autoAddCss = false

// Add selected icons to library
library.add(
  // Light
  falAnalytics,
  falArrowAltUp,
  falArrowAltToRight,
  falArrowDown,
  falArrowLeft,
  falArrowRight,
  falArrowUp,
  falArrows,
  falBalanceScale,
  falBell,
  falBoxes,
  falBinoculars,
  falBriefcase,
  falBug,
  falCalendarAlt,
  falChartArea,
  falChartBar,
  falCheck,
  falChevronDoubleLeft,
  falChevronDoubleRight,
  falChevronDown,
  falChevronLeft,
  falChevronRight,
  falChevronUp,
  falCommentAltDots,
  falCommentPlus,
  falCodeBranch,
  falCog,
  falCogs,
  falCopy,
  falClock,
  falDownload,
  falEdit,
  falExchange,
  falExclamationTriangle,
  falExternalLinkSquare,
  falEye,
  falEyeSlash,
  falFile,
  falFileExport,
  falFilter,
  falGlobe,
  falHandshake,
  falInfoCircle,
  falImage,
  falKeyboard,
  falLink,
  falLongArrowDown,
  falMoneyCheckAlt,
  falMoneyCheckEditAlt,
  falPaperclip,
  falPaperPlane,
  falPlayCircle,
  falPlay,
  falPlus,
  falQuestionCircle,
  falReceipt,
  falSave,
  falSearch,
  falSpinner,
  falSquareFull,
  falStar,
  falTachometerAltFast,
  falTasks,
  falTerminal,
  falTimes,
  falTrashAlt,
  falUserCircle,
  falUserFriends,

  // Regular
  farCheck,
  farTimes,
  farSortAmountUp,
  farSortAmountDown,

  // Solid
  fasArrowLeft,
  fasArrowRight,
  fasArrowAltUp,
  fasBell,
  fasBold,
  fasCheck,
  fasCircle,
  fasImage,
  fasInfoCircle,
  fasItalic,
  fasExclamationTriangle,
  fasFileCsv,
  fasFilePdf,
  fasFileExcel,
  fasH1,
  fasH2,
  fasH3,
  fasHorizontalRule,
  fasLink,
  fasListOl,
  fasListUl,
  fasLongArrowUp,
  fasLongArrowDown,
  fasMinus,
  fasRedo,
  fasStar,
  fasUnderline,
  fasUndo,

  // Brands
  fabCcVisa,
  fabCcAmex,
  fabCcMastercard,
  fabFacebook,
  fabFacebookSquare,
  fabPaypal,
  fabYoutube,

  // Duotone
  fadLineColumns,
  fadGripHorizontal
)

export default {
  install: function (Vue) {
    Vue.component('font-awesome-icon', FontAwesomeIcon)
    Vue.component('font-awesome-layers', FontAwesomeLayers)
  }
}
